import React from "react";
import { Link, useNavigate } from "react-router-dom";
import Page from "../../components/Page";
import CheckAllBanksOffer from "../../components/_loan/CheckAllBanksOffer";
const CheckBankOffers = () => {
  const navigate = useNavigate();
  return (
    <Page title="Cbil Dashboard">
      <section id="contact_supplier" className="ptb-50">
        <div className="container">
          <div className="row">
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="text-start mb-4">
                <button
                  onClick={() => navigate(-1)}
                  className="btn btn-primary"
                >
                  <i className="fas fa-arrow-alt-circle-left"></i> Back
                </button>
              </div>
              <CheckAllBanksOffer />
            </div>
          </div>
        </div>
      </section>
    </Page>
  );
};

export default CheckBankOffers;
